<template>
  <div class="v-container">
    <div class="v-page-header">全景素材管理</div>
    <div class="v-header">
      <div>
        <el-button @click="add()" size="small" type="primary">新增素材</el-button>
      </div>
      <div>
        <el-select size="mini" v-model="status" style="width: 180px" placeholder="转码状态筛选">
          <el-option :value="1" label="转码中"></el-option>
          <el-option :value="2" label="转码完成"></el-option>
        </el-select>
        <el-input v-model="keyword" class="v-form-item v-ml-5" size="mini" placeholder="素材名称" style="width: 180px"></el-input>
        <el-button class="v-ml-5" type="primary" size="mini" @click="getList(1)">搜索</el-button>
        <el-button size="mini" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="v-content" v-loading="loading">
      <el-table border size="small" :data="lists" height="100%">
        <el-table-column label="ID" width="60" prop="id"></el-table-column>
        <el-table-column label="缩略图" width="100" align="center">
          <template slot-scope="scope">
            <div class="cover-preview-box">
              <img class="cover-preview" :src="scope.row.thumb_preview" />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="素材名称" prop="name" />
        <el-table-column label="创建时间" prop="create_time" width="160" />
        <el-table-column align="center" label="素材状态" width="80" fixed="right">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" class="v-color-yellow">转码中</span>
            <span v-if="scope.row.status == 2" class="v-color-green">转码完成</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="140" fixed="right">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)" size="min" class="v-ml-5" type="warning">编辑</el-button>
            <el-popconfirm title="确认删除？" @onConfirm="deleteMedia(scope.row)">
              <el-button slot="reference" size="min" class="v-ml-5" type="danger" :loading="scope.row.deleteLoading">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="v-footer">
      <el-pagination
        layout="total,sizes,prev, pager, next"
        @size-change="
          (page_size) => {
            getList(page, page_size);
          }
        "
        @current-change="
          (page) => {
            getList(page);
          }
        "
        :current-page.sync="page"
        :total="total"
      />
    </div>
    <add-edit v-if="isShowAddEdit" :show.sync="isShowAddEdit" :row="row" @success="getList(1)"></add-edit>
  </div>
</template>

<script>
import addEdit from './components/add-edit';

export default {
  components: { addEdit },
  data() {
    return {
      loading: false,
      lists: [],
      page: 1,
      page_size: 10,
      total: 0,
      keyword: '',
      status: '',
      isShowAddEdit: false,
      row: null,
    };
  },

  created() {
    this.getList();
  },

  methods: {
    async getList(page, page_size) {
      this.loading = true;
      this.page = page ? page : this.page;
      this.page_size = page_size ? page_size : this.page_size;
      try {
        let res = await this.api.material.lists({
          page: this.page,
          page_size: this.page_size,
          keyword: this.keyword,
          status: this.status,
        });
        this.lists = res.data.data;
        this.total = res.data.total;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    reset() {
      this.status = '';
      this.keyword = '';
      this.getList(1);
    },

    add() {
      this.row = null;
      this.isShowAddEdit = true;
    },

    edit(row) {
      this.row = row;
      this.isShowAddEdit = true;
    },

    //单条删除
    deleteMedia(row) {
      this.$set(row, 'deleteLoading', true);
      this.doDeleteMedia([row.id], row);
    },

    //批量删除文件
    async batchDeleteMedia() {
      try {
        let ids = this.lists.filter((item) => item.active).map((item) => item.id);
        await this.$confirm('确认删除选中项?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        this.doDeleteMedia(ids);
      } catch (e) {
        console.error(e);
      }
    },

    //删除多媒体文件
    async doDeleteMedia(material_ids, row) {
      try {
        await this.api.material.delete({ material_ids });
        this.$message.success('删除成功');
        this.getList();
      } catch (e) {
        console.error(e);
      }
      if (row) {
        this.$set(row, 'deleteLoading', false);
      }
    },
  },
};
</script>

<style scoped>
.v-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cover-preview-box,
.cover-preview {
  width: 60px;
  height: 60px;
  display: block;
  margin: 0 auto;
}
</style>
